<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      OT Bill: Laser
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
<v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :filters="filters"
        :search="search"
        :actions="actions"
        dense
        :loading="loading"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:item.opp_status="{ item }">
          <v-chip :color="getColor(item.opp_status)" dark>
            {{ item.opp_status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top v-if="item.opp_status == 'open'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="create_invoice(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="orange"
                label
                outlined
                small
                ><v-icon left> mdi-motorbike </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>Bill Generate</span>
          </v-tooltip>
          <v-tooltip top v-if="item.opp_status == 'close'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="otbillview(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="success"
                label
                outlined
                small
              >
                <v-icon left> mdi-eye </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>OT Bill View</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="recieve_money(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="primary"
                label
                outlined
                small
              >
                <v-icon left> mdi-cash </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>Receive Money</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="yaglaser(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="primary"
                label
                outlined
                small
              >
                <v-icon left> mdi-message-text </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>Laser Consent Form</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="laserChart(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="primary"
                label
                outlined
                small
              >
                <v-icon left> mdi-message-text </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>Laser Chart</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>

import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      loading:true,
      headers: [
        {
          text: "OT ID",
          align: "start",
          sortable: true,
          value: "registration_no",
        },
        {
          text: "ID",
          value: "patient_id",
        },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Dcotor", value: "doctor.dr_name" },
        { text: "Operation Name", value: "operation.name" },
        // { text: "OT Date", value: "opp_date", Key: "Date" },
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Status", value: "opp_status" },

        // { text: "Create at", value: "create_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],
      filters: [
        {
          type: "date",
          key: "date",
          min: "2017-05-04",
          max: "2019-10-28",
          label: "Date",
        },
        {
          type: "select-range",
          key: "Amount",
          defaultOption: "Select price range",
          options: [
            { label: "-1000 to -501", value: { min: -1000, max: -501 } },
            { label: "-500 to -1", value: { min: -500, max: -1 } },
            { label: "0 to 499", value: { min: 0, max: 499 } },
            { label: "500 to 1000", value: { min: 500, max: 1000 } },
          ],
          label: "Price",
        },
      ],
      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Laser",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
  },
  methods: {
    initialize(date) {
      atshq
        .get("ot-bill-laser?date="+date)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.desserts = response.data.data;
          this.loading=false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    dateSelect(date) {
      this.initialize(date);
    },
    getColor(status) {
      if (status == "open") return "orange";
      else return "green";
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
      // console.log(this.desserts.item);
      alert(item.patient_id);
    },
    create_invoice(item) {
      window.location.href = "/otbill-create/" + item.registration_no;
    },
    recieve_money(item) {
      window.location.href =
        this.returnUrl +
        "front_desk/invoice/" +
        item.registration_no +
        "#otbillarea";
    },
    otbillview(item) {
      window.open(
        this.returnUrl + "printdoc/invoiceDoctorOt/" + item.registration_no
      );
    },
    admissionform(item) {
      window.open(
        this.returnUrl +
          "printdoc/opAdmissionFormRegNo/" +
          item.registration_no +
          "/0"
      );
    },
    injection(item) {
      window.open(
        this.returnUrl +
          "printdoc/avs_injectionRegNo/" +
          item.registration_no +
          "/0"
      );
    },
    yaglaser(item) {
      window.open(
        this.returnUrl + "printdoc/yagLaserRegNo/" + item.registration_no + "/0"
      );
    },
    laserChart(item) {
      window.open(
        this.returnUrl +
          "printdoc/laserProformaRegNo/" +
          item.registration_no +
          "/0"
      );
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    invoice_gen(item) {
      this.$router.push("/invoice-create/" + item.patient_id);
      // console.warn(item);
    },
  },
};
</script>